const NFTS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const NFTS_SORT_KEYS = {
  NFT_NAME: 0,
  NFT_URL: 1,
  NFT_ADDRESS: 2,
  NFT_OWNER_ADDRESS: 3,
  CONTRACT_ADDRESS: 4,
  CONTRACT_OWNER_ADDRESS: 5,
  TOTAL_SUPPLY: 6,
  PRICE_IN_MERX: 7,
  PRICE_IN_USD: 8,
  DISTRIBUTION: 9,
  CURRENT_PRICE: 10,
  ALL_TIME_HIGH: 11,
};

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const sortKeys = [
  {
    name: 'NFT Name',
    key: 'name',
    type: 'string',
    defaultSortType: NFTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'NFT URL',
    key: 'url',
    type: 'string',
    defaultSortType: NFTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'NFT Address',
    key: 'address',
    type: 'string',
    defaultSortType: NFTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'NFT Owner Address',
    key: 'owner_address',
    type: 'string',
    defaultSortType: NFTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Contract Address',
    type: 'string',
    getValue: (nft) => nft?.nft_contract?.contract_address || nft?.contract_address,
    defaultSortType: NFTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Contract Owner Address',
    type: 'string',
    getValue: (nft) => nft?.nft_contract?.contract_owner_address || nft?.contract_owner_address,
    defaultSortType: NFTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Total Supply',
    key: 'total_supply',
    type: 'number',
    defaultSortType: NFTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Price in MERX',
    key: 'price_in_mercurx',
    type: 'number',
    defaultSortType: NFTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Price in USD',
    key: 'price_in_usd',
    type: 'number',
    defaultSortType: NFTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Distribution',
    key: 'distribution',
    type: 'number',
    defaultSortType: NFTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Current Price',
    key: 'current_price',
    type: 'number',
    defaultSortType: NFTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'All Time High',
    key: 'all_time_high',
    type: 'number',
    defaultSortType: NFTS_SORT_TYPES.DESCENDING,
  },
];

const nftsQuickFilterConstants = {
  ALL: 1,
  ACTIVE: 2,
  COMPLETED: 3,
};

export {
  NFTS_SORT_KEYS,
  NFTS_SORT_TYPES,
  sortTypes,
  sortKeys,
  nftsQuickFilterConstants,
};
